import { Backdrop, Modal, Paper } from "@mui/material";
import styled from "styled-components";
import { Spacing } from "../../../config";
import CloseIcon from "@mui/icons-material/Close";
import FontStyles from "../../styles/fontStyles";
import { ButtonContained, ButtonText } from "../..";

const StyledBackdrop = styled(Backdrop)({
  backdropFilter: "blur(5px)",
  WebkitBackdropFilter: "blur(5px)",
  backgroundColor: "#00000020",
  borderRadius: 15,
});

const StyledModal = styled(Modal)({
  outlineWidth: 0,
  borderWidth: 0,
  overflow: "hidden",
  ":focus": {},
});

interface ContainerProps {
  $noMaxWidth?: boolean;
}
const Container = styled(Paper)<ContainerProps>(({ theme, $noMaxWidth }) => {
  const { spacing, palette: colors } = theme;
  return {
    "&&.MuiPaper-root": {
      position: "absolute",
      width: "auto",
      maxWidth: $noMaxWidth ? "60vw" : 450,
      maxHeight: "90vh",
      paddingBlock: Spacing(3),
      top: "50%",
      left: "50%",
      transform: `translate(-50%, -50%)`,
      outline: "none",
      backgroundColor: colors.text.primary,
      overflowY: "auto",
      borderRadius: 15,
      [theme.breakpoints.down("sm")]: {
        maxWidth: "90vw",
        width: "100%",
      },
    },
  };
});

const ContentContainer = styled.div(({ theme }) => {
  return {
    overflow: "hidden",
  };
});

const HeaderContainer = styled.div(({ theme,  }) => {
  const { spacing } = theme;
  return {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    paddingInline: spacing(2.5),
    paddingBottom: Spacing(3.5),
    // marginTop: noExit ? spacing(1.5) : spacing(0.5),
  };
});

const Close = styled(CloseIcon)(({ theme }) => {
  const { palette: colors, spacing } = theme;
  return {
    color: colors.secondary.main,
    width: spacing(3),
    height: spacing(3),
  };
});

const TextContainer = styled.div(({ theme }) => {
  return {
    color: "white",
    paddingBottom: Spacing(3.5),

    textAlign: "center",
    [`@media only screen and (max-height: 700px)`]: {
      padding: 0,
      margin: 0,
    },
  };
});
const PaddingModal = styled.div(({ theme }) => {
  return {
    paddingInline: Spacing(2.5),
    display: "flex",
    flexDirection: "row-reverse",
    justifyContent: "flex-start",
    alignItems: "center",
  };
});
const ContentText = styled.p(({ theme,  }) => {
  const { palette: colors, spacing } = theme;
  return {
    ...FontStyles.regular14,
    color: colors.text.secondary,
    textAlign: "left",
    paddingInline: spacing(3.12),
    marginBottom: spacing(0),
    marginTop: spacing(0),
  };
});
const Title = styled.p(({ theme }) => {
  const { palette: colors } = theme;
  return {
    ...FontStyles.medium16,
    color: colors.text.secondary,
    fill: colors.text.secondary,
    margin: 0,
    padding: 0,
    display: "flex",
    alignItems: "center",
    gap: "8px",
  };
});
const FooterContainer = styled.div(({ theme }) => {
  return {
    marginTop: Spacing(1),
    paddingInline: Spacing(3.5),
    display: "flex",

    justifyContent: "flex-end",
    alignItems: "center",
  };
});

const ConfirmButton = styled(ButtonContained)(({ theme }) => {
  const { spacing, palette: colors } = theme;
  return {
    "&&.MuiButton-root": {
      width: "auto",
      marginLeft: spacing(2),
      backgroundColor: colors.text.secondary,
      color: colors.text.primary,
      ...FontStyles.medium14,
      "&:hover": {
        backgroundColor: colors.primary.contrastText,
      },
    },
  };
});

const ExitButton = styled(ButtonText)(({ theme }) => {
  const { spacing, palette: colors } = theme;
  return {
    "&&.MuiButton-root": {
      textTransform: "capitalize",
      color: colors.text.secondary,
      ...FontStyles.medium14,
    },
  };
});

const Styles = {
  StyledBackdrop,
  StyledModal,
  Container,
  ContentContainer,
  HeaderContainer,
  Close,
  TextContainer,
  PaddingModal,
  ContentText,
  Title,
  FooterContainer,
  ConfirmButton,
  ExitButton,
};

export default Styles;
